import React from "react";
import {
  MDBFooter,
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBBtn,
  MDBSwitch,
} from "mdb-react-ui-kit";

import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import IncidentCreateModal from "Projects/CC_cubi_clan_project/GlobalComponents/IncidentCreateModal/IncidentCreateModal";

const FIELDS = [
  "company_name",
  "company_tagline",
  "address",
  "email",
  "social_facebook",
  "social_instagram",
  "social_youtube",
  "social_tiktok",
  "phone",
  "whatsapp",
  "show_email",
  "show_social_facebook",
  "show_social_instagram",
  "show_social_youtube",
  "show_social_tiktok",
  "show_phone",
  "show_whatsapp",
];

const DEFAULTS = {
  company_name: "Teansari",
  company_tagline:
    "Este es un proyecto ficticio que sirve como ejemplo de una página web corporativa para Teansari. Próximamente se incluirá contenido real sobre la empresa y sus productos.",
  address: "I.E.S. Miguel de Mañara, Calle Cultura, s/n, La Rinconada",
  email: "teansarisanjose@gmail.com",
  social_facebook: "https://www.facebook.com/profile.php?id=100057086515415",
  social_instagram: "https://www.instagram.com/teansarisj",
  social_youtube: "https://www.youtube.com/@teatroteansari",
  social_tiktok: "",
  phone: "",
  whatsapp: "",
  show_email: "true",
  show_social_facebook: "true",
  show_social_instagram: "true",
  show_social_youtube: "true",
  show_social_tiktok: "true",
  show_phone: "true",
  show_whatsapp: "true",
};

class FooterManager extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      values: { ...DEFAULTS },
      original: { ...DEFAULTS },
      ids: {},
      loaded: false,
      saving: false,
      incidentOpen: false,
    };
    this.handleOpenIncident = () => this.setState({ incidentOpen: true });
    this.handleCloseIncident = () => this.setState({ incidentOpen: false });
  }

  componentDidMount() {
    this.loadConfig();
  }

  async loadConfig() {
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const response = await doFetch("TEAN", "getSiteContentByPrefix?prefix=FOOTER_");
      const data = await response.json();
      const items = data && data.DATA ? data.DATA : [];
      const vals = { ...DEFAULTS };
      const ids = {};
      items.forEach((item) => {
        const key = item.contentKey.replace("FOOTER_", "");
        vals[key] = item.configValue ?? DEFAULTS[key] ?? "";
        ids[key] = item.IDContent ?? null;
      });
      this.setState({ values: vals, original: { ...vals }, ids, loaded: true });
    } catch (error) {
      console.error("Error al cargar config del footer:", error);
      this.setState({ loaded: true });
    } finally {
      if (this.props.onLoading) this.props.onLoading(false);
    }
  }

  handleChange = (key, value) => {
    this.setState((prev) => ({
      values: { ...prev.values, [key]: value },
    }));
  };

  saveConfig = async () => {
    this.setState({ saving: true });
    if (this.props.onLoading) this.props.onLoading(true);
    try {
      const { values, ids } = this.state;
      const payload = FIELDS.map((key) => ({
        IDContent: ids[key] ?? null,
        contentKey: "FOOTER_" + key,
        configValue: values[key] ?? "",
        contentType: "config",
      }));

      const response = await doFetch("TEAN", "upsertSiteContentBatch", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data && data.STATE === "SUCCESS") {
        toast.show({
          message: "Footer guardado correctamente",
          type: "success",
          position: "bottom-center",
          timeout: 3000,
        });
        const newIds = { ...ids };
        if (data.DATA) {
          data.DATA.forEach((item) => {
            const key = item.contentKey.replace("FOOTER_", "");
            newIds[key] = item.IDContent;
          });
        }
        this.setState({ original: { ...values }, ids: newIds });
      } else {
        toast.show({ message: data.MESSAGE || "Error al guardar", type: "danger" });
      }
    } catch (error) {
      console.error("Error al guardar config del footer:", error);
      toast.show({ message: "Error de conexión al guardar", type: "danger" });
    } finally {
      this.setState({ saving: false });
      if (this.props.onLoading) this.props.onLoading(false);
    }
  };

  discardChanges = () => {
    this.setState((prev) => ({ values: { ...prev.original } }));
  };

  hasChanges() {
    const { values, original } = this.state;
    return FIELDS.some((key) => values[key] !== original[key]);
  }

  render() {
    const { values, loaded, saving, incidentOpen } = this.state;
    const dirty = this.hasChanges();

    if (!loaded) return null;

    const socialLinks = [
      { key: "social_facebook", icon: "facebook-f", label: "Facebook URL" },
      { key: "social_instagram", icon: "instagram", label: "Instagram URL" },
      { key: "social_youtube", icon: "youtube", label: "YouTube URL" },
      { key: "social_tiktok", icon: "tiktok", label: "TikTok URL" },
    ];

    return (
      <MDBFooter
        bgColor="light"
        className="text-center text-lg-start text-muted mt-5 footer-admin"
      >
        {/* Save/discard toolbar */}
        <div className="d-flex justify-content-end gap-2 p-2">
          {dirty && (
            <MDBBtn color="secondary" size="sm" onClick={this.discardChanges} disabled={saving}>
              <MDBIcon fas icon="undo" className="me-1" /> Descartar
            </MDBBtn>
          )}
          <MDBBtn
            color="success"
            size="sm"
            onClick={this.saveConfig}
            disabled={!dirty || saving}
          >
            <MDBIcon fas icon="save" className="me-1" />
            {saving ? "Guardando…" : "Guardar footer"}
          </MDBBtn>
        </div>

        {/* Social links row */}
        <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
          <div className="me-5 d-none d-lg-block">
            <span>Síguenos en nuestras redes sociales:</span>
          </div>
          <div className="d-flex gap-3 align-items-center flex-wrap">
            {socialLinks.map((s) => (
              <div key={s.key} className="d-flex align-items-center gap-1">
                <MDBSwitch
                  id={`show-${s.key}-switch`}
                  checked={values[`show_${s.key}`] !== "false"}
                  onChange={(e) => this.handleChange(`show_${s.key}`, e.target.checked ? "true" : "false")}
                  title="Mostrar/ocultar"
                />
                <MDBIcon fab icon={s.icon} />
                <MDBInput
                  size="sm"
                  label={s.label}
                  value={values[s.key]}
                  onChange={(e) => this.handleChange(s.key, e.target.value)}
                  style={{ minWidth: "200px" }}
                />
              </div>
            ))}
          </div>
        </section>

        {/* Main content */}
        <section>
          <MDBContainer className="text-center text-md-start mt-5">
            <MDBRow className="mt-3">
              <MDBCol md="3" lg="4" xl="3" className="mx-auto mb-4">
                <h6 className="text-uppercase fw-bold mb-2">
                  <MDBIcon icon="gem" className="me-3" />
                  Empresa
                </h6>
                <MDBInput
                  size="sm"
                  label="Nombre de empresa"
                  value={values.company_name}
                  onChange={(e) => this.handleChange("company_name", e.target.value)}
                  className="mb-3"
                />
                <MDBInput
                  size="sm"
                  label="Descripción / eslogan"
                  type="textarea"
                  rows={3}
                  value={values.company_tagline}
                  onChange={(e) => this.handleChange("company_tagline", e.target.value)}
                />
              </MDBCol>
              <MDBCol md="4" lg="3" xl="3" className="mx-auto mb-md-0 mb-4">
                <h6 className="text-uppercase fw-bold mb-4">Contacto</h6>
                <div className="d-flex align-items-center gap-1 mb-2">
                  <MDBIcon icon="home" className="me-2" />
                  <MDBInput
                    size="sm"
                    label="Dirección"
                    value={values.address}
                    onChange={(e) => this.handleChange("address", e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center gap-1 mb-2">
                  <MDBSwitch
                    id="footer-show-email-switch"
                    checked={values.show_email !== "false"}
                    onChange={(e) => this.handleChange("show_email", e.target.checked ? "true" : "false")}
                    title="Mostrar/ocultar email"
                  />
                  <MDBIcon icon="envelope" className="me-2" />
                  <MDBInput
                    size="sm"
                    label="Email"
                    value={values.email}
                    onChange={(e) => this.handleChange("email", e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center gap-1 mb-2">
                  <MDBSwitch
                    id="footer-show-phone-switch"
                    checked={values.show_phone !== "false"}
                    onChange={(e) => this.handleChange("show_phone", e.target.checked ? "true" : "false")}
                    title="Mostrar/ocultar teléfono"
                  />
                  <MDBIcon fas icon="phone" className="me-2" />
                  <MDBInput
                    size="sm"
                    label="Teléfono"
                    value={values.phone}
                    onChange={(e) => this.handleChange("phone", e.target.value)}
                  />
                </div>
                <div className="d-flex align-items-center gap-1 mb-2">
                  <MDBSwitch
                    id="footer-show-whatsapp-switch"
                    checked={values.show_whatsapp !== "false"}
                    onChange={(e) => this.handleChange("show_whatsapp", e.target.checked ? "true" : "false")}
                    title="Mostrar/ocultar WhatsApp"
                  />
                  <MDBIcon fab icon="whatsapp" className="me-2" />
                  <MDBInput
                    size="sm"
                    label="WhatsApp (número con prefijo)"
                    value={values.whatsapp}
                    onChange={(e) => this.handleChange("whatsapp", e.target.value)}
                  />
                </div>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>

        <div
          className="text-center p-4"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
        >
          <div className="mb-2">
            <button
              className="btn btn-outline-danger btn-sm rounded-pill"
              onClick={this.handleOpenIncident}
            >
              <MDBIcon fas icon="life-ring" className="me-2" />
              Abrir incidencia
            </button>
            <IncidentCreateModal
              show={incidentOpen}
              onClose={this.handleCloseIncident}
              appCode="TEAN"
            />
          </div>
          © {new Date().getFullYear()} {values.company_name}. Todos los derechos
          reservados.
        </div>
      </MDBFooter>
    );
  }
}

export default FooterManager;
